import { connect } from 'react-redux';
import { ContactUs } from '../../components';

export default connect(null)(ContactUs);